import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "row items-center justify-between" };
const _hoisted_3 = { class: "text-h4 text-bold text-green-7" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_pdf_viewer = _resolveComponent("pdf-viewer");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    ...(_ctx.isMultipleKeiyaku
                        ? _ctx.isKojin
                            ? [{ itemId: _ctx.PageID.taikyoRoomList }]
                            : _ctx.isFromBulkRoom
                                ?
                                    [
                                        { itemId: _ctx.PageID.taikyoRoomList },
                                        { itemId: _ctx.PageID.taikyoAppliedList }
                                    ]
                                : [{ itemId: _ctx.PageID.taikyoAppliedList }]
                        : []),
                    { itemId: _ctx.PageID.kaiyakuSeisan }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.pageName), 1),
                                    _createVNode(_component_q_btn, {
                                        icon: "file_download",
                                        onClick: _ctx.downloadFileByCode,
                                        class: "q-ml-xs",
                                        color: "green-7",
                                        size: _ctx.$q.screen.gt.md ? 'md' : 'sm',
                                        padding: "4px"
                                    }, null, 8, ["onClick", "size"])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                (_ctx.blob)
                                    ? (_openBlock(), _createBlock(_component_pdf_viewer, {
                                        key: 0,
                                        pdfBlob: _ctx.blob,
                                        canvasStyle: ""
                                    }, null, 8, ["pdfBlob"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    label: _ctx.isMultipleKeiyaku ? '戻る' : 'トップに戻る',
                                    class: "btn-route col-8 col-md-4",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.back()))
                                }, null, 8, ["label"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
